import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isAuthed, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="min-h-[calc(100vh-5rem)] flex items-center justify-center"
        data-testid="auth-loading"
      >
        <div className="h-8 w-8 rounded-full border-2 border-brand-200 border-t-brand animate-spin" />
      </div>
    );
  }

  if (!isAuthed) {
    return (
      <Navigate
        to={`/signin?next=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }
  return children;
}
